import { render, staticRenderFns } from "./register.vue?vue&type=template&id=440492f7&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=440492f7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440492f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440492f7')) {
      api.createRecord('440492f7', component.options)
    } else {
      api.reload('440492f7', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=440492f7&scoped=true&", function () {
      api.rerender('440492f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authen/register.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/authen/register.vue
// module id = 706
// module chunks = 1